import React, { useRef } from "react";
import { Dialog } from "@headlessui/react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function AuditRestoreConfirmationForm({
  title,
  message,
  confirmLabel,
  confirmAction,
  setOpen,
  loading = false,
}) {
  const cancelButtonRef = useRef(null);

  return (
    <div>
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#EFF6FF]">
        <ArrowPathIcon
          className="h-6 w-6 text-[#2563EB]"
          aria-hidden="true"
        />
      </div>
      <div className="mt-3 text-center sm:mt-5">
        <Dialog.Title
          as="h3"
          className="text-base font-semibold leading-6 text-[#0F172A]"
        >
          {title}
        </Dialog.Title>
        <div className="mt-2">
          <p className="text-sm text-[#64748B]">{message}</p>
        </div>
      </div>
      <div className="mt-5 flex items-center justify-center gap-3 sm:mt-6">
        <button
          type="button"
          className="inline-flex justify-center rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm hover:bg-[#F6F8FB]"
          onClick={() => setOpen({ childComponent: null, open: false })}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="inline-flex justify-center rounded-xl border border-[#2563EB] bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#1D4ED8] disabled:opacity-50"
          onClick={confirmAction}
          ref={cancelButtonRef}
          disabled={loading}
        >
          {loading ? "Restoring…" : confirmLabel}
        </button>
      </div>
    </div>
  );
}
